<template>
  <v-tabs fixed-tabs color="transparent">
    <v-tabs-slider></v-tabs-slider>
    <v-tab key="search">
      <v-icon>search</v-icon>
    </v-tab>

    <v-tab key="favourites">
      <v-icon>favorite</v-icon>
    </v-tab>

    <v-tab-item key="search">
      <Search :id="id"></Search>
      <SearchResults></SearchResults>
    </v-tab-item>

    <v-tab-item key="favourites">
      <Favourites></Favourites>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Search from "../components/Search";
import SearchResults from "../components/SearchResults";
import Favourites from "../components/Favourites";

export default {
  components: {
    Search,
    SearchResults,
    Favourites
  },

  props: ["id"],

  data() {
    return {};
  }
};
</script>
